import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router'
import { PermissionService } from "./permission.service"
import { MenuService } from '@app/service/admin/menu.service'

@Injectable({
  providedIn: 'root'
})
export class PermissionGuard implements CanActivate {

  constructor(
    private _router: Router,
    private _permissionService: PermissionService,
    private menuService: MenuService,
  ) { }

  canActivate(route: ActivatedRouteSnapshot) {
    const isActive = this._permissionService.canActiveRule(route.data?.roles)
    isActive.subscribe(x => {
      if (!x) {
        // if(window.location.pathname != '/home') {
        //   this._router.navigate(['error', '403'])
        // } else {
        //   window.location.assign('/auth/login')
        // }
        this._router.navigate(['error', '403'])
      }
    })
    return isActive
  }
}
